var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-right text-18",class:{
    'text-white-primary':
      _vm.questionCount === null ||
      _vm.questionCount === 0 ||
      _vm.currentQuestionCount === 0,
  }},[_c('span',[_c('span',{class:{
        'text-white-primary':
          _vm.questionCount === null ||
          _vm.questionCount === 0 ||
          _vm.currentQuestionCount === 0,
        'text-brand_dark-primary':
          _vm.questionCount !== null &&
          _vm.questionCount !== 0 &&
          _vm.currentQuestionCount !== 0,
      }},[_vm._v(_vm._s(_vm.questionCount))]),_vm._v(" soalan ditemui ")])])}
var staticRenderFns = []

export { render, staticRenderFns }